var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 17,
    viewBox: "0 0 82 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_786)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.52 6.93311L10.9888 6.13623L8.52002 1.12061L6.05127 6.13623L0.52002 6.93311L4.52002 10.8394L3.58252 16.3394L8.52002 13.7456L13.4575 16.3394L12.52 10.8394L16.52 6.93311Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.52 6.93311L26.9888 6.13623L24.52 1.12061L22.0513 6.13623L16.52 6.93311L20.52 10.8394L19.5825 16.3394L24.52 13.7456L29.4575 16.3394L28.52 10.8394L32.52 6.93311Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.52 6.93311L42.9888 6.13623L40.52 1.12061L38.0513 6.13623L32.52 6.93311L36.52 10.8394L35.5825 16.3394L40.52 13.7456L45.4575 16.3394L44.52 10.8394L48.52 6.93311Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.52 6.93311L58.9888 6.13623L56.52 1.12061L54.0513 6.13623L48.52 6.93311L52.52 10.8394L51.5825 16.3394L56.52 13.7456L61.4575 16.3394L60.52 10.8394L64.52 6.93311Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.52 6.93311L74.9888 6.13623L72.52 1.12061L70.0513 6.13623L64.52 6.93311L68.52 10.8394L67.5825 16.3394L72.52 13.7456L77.4575 16.3394L76.52 10.8394L80.52 6.93311Z",
    fill: "#4C4C4C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.95,
    height: 24,
    fill: "white",
    transform: "translate(0.52002 0.72998)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 16,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.52002 16.73)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ce380191a47615f1601ff74ade4cf6c8.svg";
export { ForwardRef as ReactComponent };